import watchAttorneyRequest from './attorneyRequest';
import watchNewUserRequest from './newUserRequest';
import watchGetSelectOptions from './getSelectOptions';
import watchGetSupscriptions from './getSupscriptions';

const watchRequestUserWizardOld = [
  watchAttorneyRequest,
  watchNewUserRequest,
  watchGetSelectOptions,
  watchGetSupscriptions
];

export default watchRequestUserWizardOld;
